import { theme } from 'antd';
import type { ThemeConfig } from 'antd';

export const themeConfig: ThemeConfig = {
  algorithm: [theme.defaultAlgorithm],
  token: {
    colorPrimary: '#94724b',
    colorInfo: '#94724b',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorTextBase: '#2d2116',
    colorBgBase: '#f9f8f6',
    colorPrimaryBg: '#f5f0e8',
    colorPrimaryBgHover: '#e8dcc8',
    colorPrimaryBorder: '#d4bc94',
    colorPrimaryBorderHover: '#bfa478',
    colorPrimaryHover: '#7e5e3b',
    colorPrimaryActive: '#634b2f',
    colorPrimaryText: '#94724b',
    colorPrimaryTextHover: '#7e5e3b',
    colorPrimaryTextActive: '#634b2f',
    colorInfoBg: '#f5f0e8',
    colorInfoBgHover: '#e8dcc8',
    colorInfoBorder: '#d4bc94',
    colorInfoBorderHover: '#bfa478',
    colorInfoHover: '#7e5e3b',
    colorInfoActive: '#634b2f',
    colorInfoText: '#94724b',
    colorInfoTextHover: '#7e5e3b',
    colorInfoTextActive: '#634b2f',
    colorText: 'rgba(45, 33, 22, 0.88)',
    colorTextSecondary: 'rgba(45, 33, 22, 0.65)',
    colorTextTertiary: 'rgba(45, 33, 22, 0.45)',
    colorTextQuaternary: 'rgba(45, 33, 22, 0.25)',
    colorTextDisabled: 'rgba(45, 33, 22, 0.25)',
    colorBgContainer: '#ffffff',
    colorBgElevated: '#ffffff',
    colorBgLayout: '#f2f0ed',
    colorBgSpotlight: 'rgba(45, 33, 22, 0.85)',
    colorBgMask: 'rgba(45, 33, 22, 0.45)',
    colorBorder: '#e8e2d9',
    colorBorderSecondary: '#f2f0ed',
    borderRadius: 6,
    borderRadiusXS: 2,
    borderRadiusSM: 4,
    borderRadiusLG: 8,
    padding: 16,
    paddingSM: 12,
    paddingLG: 20,
    margin: 16,
    marginSM: 12,
    marginLG: 20,
    boxShadow: '0 2px 6px 0 rgba(0, 0, 0, 0.08)',
    boxShadowSecondary: '0 4px 10px 0 rgba(0, 0, 0, 0.12)',
  },
  components: {
    // 可以在这里添加组件级别的定制
    Layout: {
      bodyBg: '#f7f5f2',
      footerBg: '#e1d4c3',
      headerBg: '#94724b',
      headerColor: '#fff',
      lightSiderBg: '#f9f6f2',
      lightTriggerBg: '#efebdf',
      lightTriggerColor: '#94724b',
      siderBg: '#b39a77',
      triggerBg: '#dfcbb1',
      triggerColor: '#94724b',
      headerHeight: 'auto',
      footerPadding: 0,
      headerPadding: 0,
    },
  },
};
